'use client';
import IconCollection from '@/components/IconCollection/IconCollection';
import { useMobileNavStore } from '@/store/mobileNavStore';
type ButtonComponentProps = {
  name: string;
  className: string;
};
const ButtonComponent = ({ name, className }: ButtonComponentProps) => {
  const { toggleDrawer, toggleSearch } = useMobileNavStore();
  return (
    <button
      className={className}
      onClick={name === 'burgerMenu' ? toggleDrawer : toggleSearch}
      style={{ textDecoration: 'none' }}
    >
      <IconCollection name={name} />
    </button>
  );
};

export default ButtonComponent;
